<template>
  <div>
    <div>
      <div class="input-group">
        <input
          type="number"
          placeholder="Скидка"
          v-model="invoice.discount"
          class="form-control"
        />
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="r1" v-model="invoice.discount_type" value="2"
               class="custom-control-input"/>
        <label class="custom-control-label" for="r1">Общая сумма в валюте накладной</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="r2" v-model="invoice.discount_type" value="1"
               class="custom-control-input"/>
        <label class="custom-control-label" for="r2">Процент с каждой позиции</label>
      </div>
    </div>
    <div class="form-group">
      <label for="">Дополнительные расходы</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">По стоимости</span>
        </div>
        <input
          type="number"
          placeholder="Расход"
          v-model="invoice.extra_settings.expenses_by_price"
          class="form-control"
        />
        <div class="input-group-prepend">
          <span class="input-group-text">По упаковкам</span>
        </div>
        <input
          type="number"
          placeholder="Расход"
          v-model="invoice.extra_settings.expenses_by_qty"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['invoice'],
  created() {
    if (!this.invoice.extra_settings) this.invoice.extra_settings = {};
  }
}

</script>
